// CORE IMPORTS
import { useHistory } from "react-router-dom";
import { trackEvent } from "src/Amplitude";

// COMPONENTS
import { AlertCard, AlertStyleType } from "src/components/alerts/AlertCard";

// REDUX
import { useUserSlice } from "src/store/features/user.slice";
import usePermission from "src/utils/hooks/usePermission";

interface Use2FACheckOptions {
  trackingCategory?: "Swap" | "Target_Orders" | "Scheduled_Orders";
  onRedirect?: () => void;
}

interface Use2FACheckReturn {
  is2FAEnabled: boolean;
  handle2FACheck: () => boolean;
  TwoFAAlert: () => JSX.Element | null;
}

export const use2FACheck = (options: Use2FACheckOptions = {}): Use2FACheckReturn => {
  const { trackingCategory = "Swap", onRedirect } = options;
  const history = useHistory();
  const { is2FAEnabled } = useUserSlice();
  const { isGuest } = usePermission();

  const handle2FACheck = (): boolean => {
    if (!is2FAEnabled) {
      trackEvent("User clicked to enable 2FA", { button: "Enable_2FA" }, trackingCategory);

      if (onRedirect) {
        onRedirect();
      }

      history.push("/settings/security");
      return false;
    }
    return true;
  };

  const TwoFAAlert = (): JSX.Element | null => {
    if (!is2FAEnabled && !isGuest) {
      return (
        <AlertCard
          titleText="Action Required"
          subText="For your security Caleb & Brown requires you to enable two factor authentication (2FA). Once enabled, you'll be able to lodge withdrawal requests, add new addresses to your account and place trades."
          styleType={AlertStyleType.TRADE}
        />
      );
    }
    return null;
  };

  return {
    is2FAEnabled: !!is2FAEnabled, // ts complained if this was not a boolean, hence conversion
    handle2FACheck,
    TwoFAAlert,
  };
};
